import { BitfApiRequestPart } from '@bitf/core/api-call-state/bitf-api-request-part';
import { EApiRequestPartKeys, EBitfApiRequestPartsNames } from '@enums';
import { IBitfApiRequestPartChips } from '@interfaces';

export class AdminRouteLogSummariesListFilterApiRequestPart extends BitfApiRequestPart {
  constructor() {
    super(EApiRequestPartKeys.FILTERS, EBitfApiRequestPartsNames.FILTER);
  }

  build(): void {
    this.chips = [];
    this.part = '';

    const formValue = this.formValue || {};
    const parts: string[] = [];

    if (formValue.fromDate) {
      const fromIso = this.toODataDateTime(formValue.fromDate, false);
      parts.push(`startEventTime ge ${fromIso}`);
      this.chips.push({
        apiRequestPartItemName: 'fromDate',
        chip: [{ key: 'fromDate', value: this.toChipDate(formValue.fromDate) }],
        label: 'ADMIN.ROUTE_LOG_SUMMARIES.FILTERS.FROM_DATE',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.toDate) {
      const toIso = this.toODataDateTime(formValue.toDate, true);
      parts.push(`startEventTime le ${toIso}`);
      this.chips.push({
        apiRequestPartItemName: 'toDate',
        chip: [{ key: 'toDate', value: this.toChipDate(formValue.toDate) }],
        label: 'ADMIN.ROUTE_LOG_SUMMARIES.FILTERS.TO_DATE',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.driverId) {
      parts.push(`startswith(driverInfo,'${formValue.driverId} -')`);
      this.chips.push({
        apiRequestPartItemName: 'driverId',
        chip: [
          {
            key: formValue.driverId,
            value: (this.data && this.data.driverLabel) || String(formValue.driverId),
          },
        ],
        label: 'Driver',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.busId) {
      parts.push(`startswith(busInfo,'${formValue.busId} -')`);
      this.chips.push({
        apiRequestPartItemName: 'busId',
        chip: [
          {
            key: formValue.busId,
            value: (this.data && this.data.busLabel) || String(formValue.busId),
          },
        ],
        label: 'Bus',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.routePlanId) {
      parts.push(`startswith(routePlanInfo,'${formValue.routePlanId} -')`);
      this.chips.push({
        apiRequestPartItemName: 'routePlanId',
        chip: [
          {
            key: formValue.routePlanId,
            value: (this.data && this.data.routePlanLabel) || String(formValue.routePlanId),
          },
        ],
        label: 'Route plan',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.childrenListId) {
      parts.push(`startswith(childrenListInfo,'${formValue.childrenListId} -')`);
      this.chips.push({
        apiRequestPartItemName: 'childrenListId',
        chip: [
          {
            key: formValue.childrenListId,
            value: (this.data && this.data.childrenListLabel) || String(formValue.childrenListId),
          },
        ],
        label: 'Children list',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    if (formValue.minPickUpChildren != null && formValue.minPickUpChildren !== '') {
      parts.push(`numOfPickUpChildren ge ${formValue.minPickUpChildren}`);
      this.chips.push({
        apiRequestPartItemName: 'minPickUpChildren',
        chip: [{ key: 'minPickUpChildren', value: String(formValue.minPickUpChildren) }],
        label: 'Min pick-up',
        apiRequestPartKey: this.key,
      } as IBitfApiRequestPartChips);
    }

    this.part = parts.join(' and ');
  }

  private toODataDateTime(date: Date | string, endOfDay: boolean): string {
    const d = date instanceof Date ? new Date(date) : new Date(date);
    if (endOfDay) {
      d.setHours(23, 59, 59, 999);
    } else {
      d.setHours(0, 0, 0, 0);
    }
    return d.toISOString();
  }

  private toChipDate(date: Date | string): string {
    const d = date instanceof Date ? date : new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${d.getFullYear()}`;
  }
}
